
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import CampoEmail from '@/core/components/UI/CampoEmail.vue';
import { useAppBase } from '@/core/composables/AppBase';
import Card from '@/core/components/UI/Card.vue';
import SelecionarData from '@/core/components/UI/SelecionarData.vue';
import CampoCep from '@/core/components/UI/CampoCep.vue';
import CampoNumerico from '../components/UI/CampoNumerico.vue';
import GerenciadorAutenticacao from '@/core/gerenciadores/GerenciadorAutenticacao';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import ServicoUtilitario from '@/servicos/ServicoUtilitario';
import { ETipoControleArea } from '@/models/Enumeradores/ETipoControle';
import { EStatusResposta, IResposta } from '@/core/models/IResposta';
import { IDTOFichaJagua } from '@/models/DTO/IDTOFichaJagua';
import CampoCnpj from '../components/UI/CampoCnpj.vue';
import ServicoApp from '@/servicos/ServicoApp';

export default defineComponent({
  name: 'FichaCadastro',
  components: {
    Card,
    SelecionarData,
    CampoEmail,
    CampoCnpj,
    CampoCep,
    CampoNumerico,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi,
    } = useAppBase();
    const servicoApp = new ServicoApp();
    const servicoUtilitario = new ServicoUtilitario();
    const gerenciadorAutenticacao = new GerenciadorAutenticacao();
    const state = reactive({
      cadastroRelizadoComSucesso: false,
      fichaCadastro: {} as IDTOFichaJagua,
      cep: '',
      cpfCnpj: '',
      apresentarMensagemAlerta: false,
      consultandoCnpj: false,
      consultandoCep: false,
      gerandoPdf: false,
    });

    async function consultaCep() {
      if (UtilitarioGeral.valorValido(state.cep) && UtilitarioGeral.validaValorComLimiteCaracteres(state.cep, 8)) {
        state.consultandoCep = true;
        const retornoConsultaCep = await servicoUtilitario.consultaCep(state.cep);
        if (retornoConsultaCep !== undefined) {
          state.fichaCadastro.endereco = retornoConsultaCep.logradouro;
          state.fichaCadastro.endereco += ` ${retornoConsultaCep.complemento}`;
          state.fichaCadastro.bairro = retornoConsultaCep.bairro;
          state.fichaCadastro.cidade = `${retornoConsultaCep.cidade} - ${retornoConsultaCep.uf}`;
        }
      }
      state.consultandoCep = false;
    }

    async function consultaCnpj() {
      if (UtilitarioGeral.valorValido(state.fichaCadastro.cnpj) && UtilitarioGeral.validaValorComLimiteCaracteres(state.fichaCadastro.cnpj, 14)) {
        if (state.fichaCadastro.cnpj !== state.cpfCnpj) {
          state.consultandoCnpj = true;
          const retornoConsultaCnpj = await servicoUtilitario.consultaCnpj(state.fichaCadastro.cnpj);
          if (retornoConsultaCnpj !== undefined && UtilitarioGeral.valorValido(retornoConsultaCnpj.razaoSocial)) {
            state.fichaCadastro.dataFundacao = retornoConsultaCnpj.dataInicioAtividade;
            state.fichaCadastro.razaoSocial = retornoConsultaCnpj.razaoSocial;
            state.fichaCadastro.nomeFantasia = retornoConsultaCnpj.nomeFantasia;
            state.fichaCadastro.emailContato = retornoConsultaCnpj.contato.email;
            state.fichaCadastro.telefonesContato = retornoConsultaCnpj.contato.telefonePrincipal;
            state.cep = retornoConsultaCnpj.endereco.cep;
            state.fichaCadastro.endereco = retornoConsultaCnpj.endereco.logadouro;
            state.fichaCadastro.endereco += ` ${retornoConsultaCnpj.endereco.numero}`;
            state.fichaCadastro.endereco += ` ${retornoConsultaCnpj.endereco.complemento}`;
            state.fichaCadastro.endereco += ` CEP: ${retornoConsultaCnpj.endereco.cep}`;
            state.fichaCadastro.bairro = retornoConsultaCnpj.endereco.bairro;
            state.fichaCadastro.cidade = `${retornoConsultaCnpj.endereco.cidade} - ${retornoConsultaCnpj.endereco.uf}`;
          }
        }
      }
      state.consultandoCnpj = false;
    }

    function limparDados() {
      state.cadastroRelizadoComSucesso = false;
      state.cep = '';
      state.fichaCadastro = {} as IDTOFichaJagua;
      state.fichaCadastro.representante = 'Paulo Afonso Silva dos Santos';
      state.fichaCadastro.atacado = false;
      state.fichaCadastro.varejo = false;
      state.fichaCadastro.institucional = false;
      state.fichaCadastro.grandesRedes = false;
      state.fichaCadastro.foodService = false;
      state.fichaCadastro.industria = false;
      state.fichaCadastro.estimativaVendasMes = 0;
      state.fichaCadastro.limiteCreditoSolicitado = 0;
    }

    onBeforeMount(async () => {
      limparDados();
      gerenciadorAutenticacao.salvarIdentificadorParceiro('9999');
      document.documentElement.style.setProperty('--primary', '#083e89');
      document.documentElement.style.setProperty('--primary-light', '#e0edff');
      document.documentElement.style.setProperty('--primary-dark', '#99ca3b');
    });

    async function gerarPdf() {
      appBase.resposta = {} as IResposta;
      state.apresentarMensagemAlerta = false;

      apresentarComunicacaoApi('Aguarde por favor...');
      state.gerandoPdf = true;
      const resposta = await servicoApp.fichaCadastro(state.fichaCadastro);
      state.gerandoPdf = false;
      if (resposta.status === EStatusResposta.Sucesso) {
        appBase.exibirComunicaoApi = false;
        state.cadastroRelizadoComSucesso = true;
        window.open(resposta.link, '_blank');
      } else {
        state.apresentarMensagemAlerta = true;
      }
    }

    return {
      appBase,
      state,
      ETipoControleArea,
      UtilitarioGeral,
      UtilitarioMascara,
      consultaCep,
      gerarPdf,
      limparDados,
      consultaCnpj,
    };
  },
});
